<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a>To Brian Thomsen,<br/>with much affection</p>
<div class="pagebreak">
<p class="linespace"> </p>
<p class="image"><a id="page_6"></a><img alt="Images" src="images/map.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6c9cde90